import { render, staticRenderFns } from "./text-arrow.vue?vue&type=template&id=a0cf6332&scoped=true&"
import script from "./text-arrow.vue?vue&type=script&lang=js&"
export * from "./text-arrow.vue?vue&type=script&lang=js&"
import style0 from "./text-arrow.vue?vue&type=style&index=0&id=a0cf6332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cf6332",
  null
  
)

export default component.exports